import { GenEnum } from "./../shell/shared/general.enum";
import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { List } from "linqts";
import { ToastsManager } from "ng2-toastr/ng2-toastr";

import { UserService } from "../core/service/user.service";
import { BaseComponent } from "../core/component/Base.Component";
import { AppConstants } from "../app.constant";
import { EmployeeinfohdrService } from "../shell/forms/Employee-Profile/Employeeinfohdr/employee-profile/employee-profile.service";
import { IxsloaderComponent } from "../components/ixsloader/ixsloader.component";
import { Http } from "@angular/http";
import { Observable } from "rxjs";
import { ErrorComponent } from "../components/error/error.component";
import { errorArgs } from "../components/error/error.config";

@Component({
  templateUrl: "login.component.html",
  styleUrls: ["login.component.css"],
})
export class LoginComponent extends BaseComponent {
  show_button: Boolean = false;
  show_eye: Boolean = false;
  model: any = {};
  private instanceList = [];
  returnUrl: string;
  dto;
  @ViewChild("error") errorForm: ErrorComponent;
  @ViewChild('passwordd') myInput: ElementRef;

  clientid: Number = 0;

  height: any;
  width: any;

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private http: Http
  ) {
    
    super();
    this.localStorage.clear();

    this.clientid = AppConstants.settings.clientid;
    this.getData().subscribe((i: ConstantClass) => {
      if (
        i.Clients.length > 0 &&
        i.Clients.filter((o) => o.hostname === window.location.hostname)[0]
      ) {
        let obj = i.Clients.filter(
          (o) => o.hostname === window.location.hostname
        )[0];

        this.height = obj && obj.height ? obj.height : 150;

        this.width = obj && obj.width ? obj.width : 160;

        if (this.image && this.image.nativeElement) {
          let url =
            AppConstants.urls.api.base.replace("api/", "") +
            GenEnum.Image.imageUrl +
            obj.filename;

          this.localStorage.set("clientlogo", url);
          this.image.nativeElement.src = url;
        }

        if (obj && Number(obj.Id) > 0) {
          this.clientid = Number(obj.Id);
        }
      }
    });
    
  }

  async ngOnInit() {}

      public getData(): Observable<any> {
    const a = this.http
      .get("../../assets/IXS/resultJSON.json")
      .map((res: any) => {
        return res.json();
      });
    return a;
  }

  toggleFocus() {
    const inputElement = this.myInput.nativeElement;
    if (!this.show_eye) {
      inputElement.blur(); // Remove focus
    } else {
      inputElement.focus(); // Set focus
    }
  }

  @ViewChild(IxsloaderComponent) loader: IxsloaderComponent;
  @ViewChild("image") image: ElementRef;


  async login() {
    this.loader.startLoading();
    this.dto = await this.userService.login(
      this.model.username,
      this.model.password,
      Number(this.clientid)
    );
    if (this.dto.IsSuccess) {
      if (this.dto && this.dto.Data && this.dto.Data.Session) {
        this.localStorage.set(
          "token",
          "bearer ".concat(this.dto.Data.Session.token)
        );

        const users = this.dto.Data.User;
        if (users) {
          this.localStorage.set("utuser", JSON.stringify(users.utuser));
        }

        const username = users.username;
        const fullname = users.fullname;
        const userpic = users.userpic;
        const clients = users.utuserclients;
        const utuserents = users.utuserents;
        this.localStorage.set("utuserents", JSON.stringify(utuserents));
        this.localStorage.set("utapp", JSON.stringify(this.dto.Data.Apps));
        const clientInfo = new List<any>(clients)
          .Where((x) => x.isdefault === true)
          .FirstOrDefault().utclient;
        this.localStorage.set("Fullname", fullname);
        this.localStorage.set("User", username);
        this.localStorage.set("userpic", userpic);

        if (clientInfo) {
          this.localStorage.set("ClientStxt", clientInfo.clientstxt);
          this.localStorage.set("ClientCode", clientInfo.clientcode);
          this.localStorage.set("clientid", clientInfo.clientid);
        }
        if (clients) {
          this.localStorage.set("userclients", JSON.stringify(clients));
        }
        if (this.dto && this.dto.Data && this.dto.Data.Apps) {
          var appInfo;
          if (this.dto.Data.Apps.length === 1)
            appInfo = new List<any>(this.dto.Data.Apps).FirstOrDefault();
          else
            appInfo = new List<any>(this.dto.Data.Apps).FirstOrDefault(
              (x) => x.appcode === AppConstants.settings.appCode
            );

          if (appInfo) {
            const instanceInfo = new List<any>(
              appInfo.utdatabase.utinstances
            ).FirstOrDefault(
              (x) => x.instancecode === AppConstants.settings.instancecode
            );

            if (instanceInfo) {
              this.localStorage.set("apiUrl", instanceInfo.apiurl + "api/");
              this.localStorage.set("OnlyUrl", instanceInfo.apiurl);

              this.errorForm.showErrors(
                "Logged in successfully",
                "Authenticated",
                GenEnum.ErrorTypes.Success,
                2
              );
            } else {
              this.errorForm.showErrors("Instance does not exist.");
            }
          } else {
            this.errorForm.showErrors(
              "Application: " +
                AppConstants.settings.appCode +
                " not registered with user"
            );
          }
        }
      } else {
        this.errorForm.showErrors("User is not assigned this application.");
      }

      this.loader.stopLoading();
    } else {
      this.loader.stopLoading();
      this.errorForm.showErrors(this.dto.Errors);
    }
  }

  confirm(value: errorArgs) {
    let utuser = JSON.parse(this.localStorage.get("utuser"));

    if (value.value === 1 && value.type === GenEnum.ErrorTypes.Success) {
      if (
        utuser.usercatid == GenEnum.User_Category.Employee ||
        utuser.usercatid == GenEnum.User_Category.Admin
      ) {
        this.navigate("userclients");
      } else if (utuser.usercatid === GenEnum.User_Category.Parent) {
        this.navigate("childs");
      } else
        this.errorForm.showErrors(
          "User is not authorized for this application.",
          "Info",
          GenEnum.ErrorTypes.Error,
          2
        );
    }
  }

  showPassword() {
    this.show_button = !this.show_button;
    this.show_eye = !this.show_eye;
  }
  
}

export class ConstantClass {
  Clients: Clients[];
}

interface Clients {
  Id: Number;
  code: string;
  name: string;
  description: string;
  hostname: string;
  filename: string;
  height: any;
  width: any;
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts